import { jsx as _jsx } from "react/jsx-runtime";
/**
 * DatabricksIcon - official Databricks brand logo component
 *
 * Renders the official Databricks icon from the Databricks brand guidelines
 * as an inline SVG.
 *
 * Usage rules (context/iconography.md):
 * - Do not apply CSS color (fill uses official brand color)
 * - Do not recolor or modify the paths
 * - Use `size` prop for scaling - do not change viewBox
 * - Only use for Databricks identity in integration catalog / resource display
 */
export function DatabricksIcon({ size = 20, className }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": "true", className: className, children: _jsx("path", { d: "M.95 14.184L12 20.403l9.919-5.55v2.21L12 22.662l-10.484-5.96-.565.308v.77L12 24l11.05-6.218v-4.317l-.515-.309L12 19.118l-9.867-5.653v-2.21L12 16.805l11.05-6.218V6.32l-.515-.308L12 11.974 2.647 6.681 12 1.388l7.76 4.368.668-.411v-.566L12 0 .95 6.27v.72L12 13.207l9.919-5.55v2.26L12 15.52 1.516 9.56l-.565.308Z", fill: "#FF3621" }) }));
}
//# sourceMappingURL=DatabricksIcon.js.map